<template>
  <div>
     <div :class="className" :id="id" :style="{ height: height, width: width }" />
  </div>
</template>

<script>
export default {
  name: "radar1",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "200px"
    },
      chartData: {
          type: Object
      },
    center: {
      type: Array
    }
  },
  data() {
    return {
      chart: null,
      map: null
    };
  },
    mounted() {
        if (this.chartData) {
            this.initChart();
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return;
        }
        this.chart.dispose();
        this.chart = null;
    },
    watch: {
        chartData() {
            if (this.chart) {
                this.chart.dispose();
                this.chart = null;
            }
            this.initChart(); 
        }
    },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById(this.id));

      var option = {
          grid: {
              left: "3%",
              right: "4%",
              bottom: "0%",
              top: "20%",
              containLabel: true
          },
          radar: {
              // shape: 'circle',
              name: {
                  textStyle: {
                      color: '#cbeeff',
                      fontSize: 10
                  }
              },
              // splitArea: {
              //     areaStyle: {
              //         color: ['#fff', '#fff', '#fff', '#fff'],
              //         shadowColor: 'rgba(0, 100, 0, 0.3)'
              //     }
              // },
              axisLine: {
                // 坐标轴线
                show: true, // 默认显示，属性show控制显示与否
                lineStyle: {
                  width: 1,
                  color: "#096c93"
                }
              },
              splitArea: {
                  show: true,
                  areaStyle: {
                      color: ["rgba(255,255,255,0.08)", "rgba(255,255,255,0.08)"] // 图表背景网格的颜色
                  }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  width: 1,
                  color: "#096c93" // 图表背景网格线的颜色
                }
              },
              indicator:this.chartData.indicator,
              /*indicator: [


                  { text: "交通 ", max: 6500 },
                  { text: "卫生", max: 16000 },
                  { text: "安全 ", max: 30000 },
                  { text: "配套设施 ", max: 38000 },
                  { text: "消费", max: 52000 },
                  { text: "服务", max: 25000 },
                  { text: "景观", max: 6500 },
                  { text: "体验", max: 16000 }
              ]*/
          },
          series: [{
              type: 'radar',
              symbol: "none",
              data: [
                  {
                      value: this.chartData.valueList,
                      name: '数据',
                      itemStyle: {
                          normal: {
                              color: 'rgba(5, 128, 242, 0.8)'
                          }
                      },
                      areaStyle: {
                          normal: {
                              color: '#0084ff'
                          }
                      }
                  }
              ]
          }]
      }
        this.chart.setOption(option)

     /* this.chart.setOption({
        title: {
          // text: "预算 vs 开销（Budget vs spending）",
          // subtext: "纯属虚构"
        },
        tooltip: {},
        /!*     legend: {
          orient: "vertical",
          x: "right",
          y: "bottom",
          data: ["预算分配（Allocated Budget）", "实际开销（Actual Spending）"]
        },*!/
          // data: ["西湖", "广州市长隆旅游度假区","长白山","上海迪士尼乐园","三亚市"]

        radar: {
          name: {
            textStyle: {
              color: "#fff",
              backgroundColor: "#999",
              borderRadius: 3,
              padding: [3, 5]
            }
          },
          indicator: [
            { text: "交通 ", max: 100 },
            { text: "卫生", max: 100 },
            { text: "安全 ", max: 100 },
            { text: "配套设施 ", max: 100 },
            { text: "消费", max: 100 },
            { text: "服务", max: 100 },
            { text: "景观", max: 100 },
            { text: "体验", max: 100 }
          ]
        },
        calculable: true,
        series: [
          {
            // name: "预算 vs 开销（Budget vs spending）",
            type: "radar",
            data: [
              {
                value: [60, 70, 80, 60, 70, 80, 90, 70],
                // name: "预算分配（Allocated Budget）"
              }
            ]
          }
        ]
      });*/
    }
  }

};
</script>
<style scoped lang="less"></style>
